export const getCodeGdsByDocumentType = (documentType, documentsCatalog) =>
  documentsCatalog?.find(({ code }) => code === documentType)?.codeGds || documentType
